import { render, staticRenderFns } from "./FlightListItem.vue?vue&type=template&id=b74b5628&scoped=true&"
import script from "./FlightListItem.vue?vue&type=script&lang=js&"
export * from "./FlightListItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightListItem.vue?vue&type=style&index=0&id=b74b5628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b5628",
  null
  
)

export default component.exports